module.exports = __webpack_public_path__ + "static/media/master-shot-2-mobile.5a3f08c2.webp";